import { ILocalizable } from './localized';

export type IEquatable = number | string;

export type SchemaType = string;

export type ISchema = {
  id: IEquatable;
  schema?: string;
};

export type IEntity = ISchema & Record<string, unknown>;

export type INamedEntity = IEntity & {
  name: ILocalizable;
};

export type ITitledEntity = IEntity & {
  title: ILocalizable;
};

export type IOption = Record<string, any> & {
  id: IEquatable;
  name: string;
};

export type IFeature = Record<string, any> & {
  id: IEquatable;
  title: string;
  // !!! todo remap to name
};

export type IFeatureType = IEntity & {
  id: string;
  title: string;
  mode: string;
  features: IFeature[];
};
